import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authRegister, authLogout } from "../lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { const u = await authMe(); setUser(u); return u; }
    catch { setUser(null); return null; }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => { const r = await authLogin({ email, password }); setUser(r.user); return r; };
  const register = async (payload) => { const r = await authRegister(payload); setUser(r.user); return r; };
  const logout = async () => { await authLogout(); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
